import React from "react";
import PropTypes from "prop-types";
import styles from "./WorkHistory.css";
import WorkItem from "./WorkItem/WorkItem";

const WorkHistory = ({ history }) => {
  const workItems = history.map(item => <WorkItem history={item} />);

  return (
    <div className={styles.WorkHistory}>
      <div className={styles.WorkHeader}>
        <h2>Work History</h2>
        {workItems}
      </div>
    </div>
  );
};

WorkHistory.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired
};

export default WorkHistory;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/WorkHistory/WorkHistory.js